import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["actionPlan"];

  toggleActionPlan() {
    if (event.target.value == "1") {
      this.actionPlanTarget.classList.add("d-none");
    } else {
      this.actionPlanTarget.classList.remove("d-none");
    }
  }
}
